export const getCustomWeekParams = (startDate, endDate, timePeriod) => {
	return timePeriod === -1 ? `&startWeek=${startDate}&endWeek=${endDate}` : '';
};

export const defaultColumnPreferences = {
	OMNI: [
		{
			id: '1',
			name: 'Sales',
			metrics: [
				{
					id: '101',
					name: 'Net Sales',
					shortName: 'NET_SALES',
				},
				{
					id: '102',
					name: 'Units',
					shortName: 'UNITS',
				},
				{
					id: '103',
					name: 'AUR',
					shortName: 'AUR',
				},
			],
		},
		{
			id: '2',
			name: 'Fulfillment Channel Sales Breakdown',
			metrics: [
				{
					id: '201',
					name: 'Buy In Store',
					shortName: 'BIS',
				},
				{
					id: '202',
					name: 'Pick Up',
					shortName: 'PICKUP',
				},
				{
					id: '203',
					name: 'Delivery',
					shortName: 'DELIVERY',
				},
				{
					id: '204',
					name: 'Ship From Store',
					shortName: 'SFS',
				},
				{
					id: '205',
					name: 'Ship To Home',
					shortName: 'S2H',
				},
				{
					id: '206',
					name: 'Ship to Store',
					shortName: 'S2S',
				},
			],
		},
	],
	STORE: [
		{
			id: '1',
			name: 'Sales',
			metrics: [
				{
					id: '101',
					name: 'Net Sales',
					shortName: 'NET_SALES',
				},
				{
					id: '102',
					name: 'Units',
					shortName: 'UNITS',
				},
				{
					id: '103',
					name: 'AUR',
					shortName: 'AUR',
				},
			],
		},
		{
			id: '2',
			name: 'Fulfillment Channel Sales Breakdown',
			metrics: [
				{
					id: '201',
					name: 'Buy In Store',
					shortName: 'BIS',
				},
				{
					id: '202',
					name: 'Pick Up',
					shortName: 'PICKUP',
				},
				{
					id: '203',
					name: 'Delivery',
					shortName: 'DELIVERY',
				},
				{
					id: '204',
					name: 'Ship From Store',
					shortName: 'SFS',
				},
			],
		},
		{
			id: '3',
			name: 'Inventory',
			metrics: [],
		},
		{
			id: '4',
			name: 'Online Pickup and Delivery',
			metrics: [],
		},
		{
			id: '5',
			name: 'Replenishment',
			metrics: [],
		},
		{
			id: '6',
			name: 'Points of Distribution',
			metrics: [],
		},
		{
			id: '7',
			name: 'Velocity',
			metrics: [],
		},
	],
	ECOM: [
		{
			id: '1',
			name: 'Sales',
			metrics: [
				{
					id: '101',
					name: 'Net Sales',
					shortName: 'NET_SALES',
				},
				{
					id: '102',
					name: 'Units',
					shortName: 'UNITS',
				},
				{
					id: '103',
					name: 'AUR',
					shortName: 'AUR',
				},
			],
		},
		{
			id: '2',
			name: 'Fulfillment Channel Sales Breakdown',
			metrics: [
				{
					id: '205',
					name: 'Ship To Home',
					shortName: 'S2H',
				},
				{
					id: '206',
					name: 'Ship to Store',
					shortName: 'S2S',
				},
			],
		},
	],
};
